module.exports = __webpack_public_path__ + "static/media/logo-primary.15967c83.svg";